import { GROUP_PERMISSIONS, ORGANIZATION_PERMISSIONS, PERMISSION_LABELS } from '@/constants';

export const getDefaultPermissions = permissions =>
  Object.keys(permissions)
    .sort((a, b) => permissions[b] - permissions[a])
    .map(key => ({
      key,
      value: false,
    }));

export const getPermissionLabels = () =>
  Object.keys(PERMISSION_LABELS)
    .sort((a, b) => b - a)
    .map(key => PERMISSION_LABELS[key]);

export const getDefaultOrgPermissions = () => getDefaultPermissions(ORGANIZATION_PERMISSIONS);

export const getDefaultGroupPermissions = () => getDefaultPermissions(GROUP_PERMISSIONS);

export const getEmptyGroup = () => ({
  id: null,
  name: null,
  permissions: getDefaultPermissions(GROUP_PERMISSIONS),
});

export const getEmptyOrganization = () => ({
  id: null,
  name: null,
  permissions: getDefaultPermissions(ORGANIZATION_PERMISSIONS),
  groups: [getEmptyGroup()],
});
